import { useTranslation } from "react-i18next";
import { AppShell } from "../../components/layout/AppShell";
import { SalesNav } from "./SalesNav";

// قوقعة مشتركة لكل شاشات المبيعات: عنوان + تبويبات.
export const SalesShell = ({ titleKey, actions, children }) => {
  const { t } = useTranslation();

  return (
    <AppShell title={t("sales.title")} subtitle={t(`sales.tabs.${titleKey}`)} actions={actions}>
      <div className="grid gap-6">
        <SalesNav />
        {children}
      </div>
    </AppShell>
  );
};
